
import { TextField, MenuItem, InputAdornment } from '@mui/material';
import { FaGlobeAsia } from 'react-icons/fa';

const indianStates = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
];

const IndianStatesSelect = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  name = 'stateRegionProvince',
  label = 'State / Region / Province',
  className,
  required = true,
  ...otherProps
}) => {
  return (
    <TextField
      select
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      className={className}
      fullWidth
      variant="standard"
      error={!!error}
      helperText={helperText}
      required={required}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 200,
              width: 250,
            },
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FaGlobeAsia color="#4D0054" />
          </InputAdornment>
        ),
      }}
      {...otherProps}
    >
      <MenuItem value="" disabled>
        {required ? '-- Select State --' : 'None'}
      </MenuItem>
      {indianStates.map((state) => (
        <MenuItem key={state} value={state}>
          {state}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default IndianStatesSelect;